import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * MiniTile.tsx
 *
 **/
import { Link } from 'react-router-dom';
import { ArrowRight } from '../../icons';
import { classNames } from '../../utils';
import { roundToRelativeScale } from '../../utils/number';
import styles from './MiniTile.module.css';
const MiniTile = ({ title, value, unit, link, className, diff, diffValueColor, pdf, }) => {
    return (_jsx("div", Object.assign({ className: className ? className : styles.miniTile }, { children: _jsxs("div", Object.assign({ className: styles.content }, { children: [_jsx("div", Object.assign({ className: pdf ? styles.title : classNames(styles.title, styles.bold) }, { children: title }), void 0), _jsxs("div", Object.assign({ className: styles.state }, { children: [_jsx("div", Object.assign({ className: styles.value }, { children: value }), void 0), _jsx("div", Object.assign({ className: styles.unit }, { children: unit }), void 0)] }), void 0), diff &&
                    diff.map((dif) => {
                        const { value, suffix, diffFrom } = dif;
                        const valueString = typeof value === 'number' && value !== null
                            ? suffix !== undefined
                                ? `${roundToRelativeScale(value)} ${suffix}`
                                : `${roundToRelativeScale(value)}`
                            : '';
                        if (value !== null) {
                            return (_jsxs("div", Object.assign({ className: styles.diff }, { children: [_jsx("div", Object.assign({ className: styles.diffValue, style: { color: diffValueColor } }, { children: value !== null && value >= 0
                                            ? `+ ${valueString}`
                                            : `${valueString}` }), void 0), _jsx("div", Object.assign({ className: styles.diffFrom }, { children: `from last ${diffFrom}` }), void 0)] }), void 0));
                        }
                    }), link && (_jsx("div", Object.assign({ className: styles.link }, { children: _jsxs(Link, Object.assign({ to: link }, { children: ['Breakdown', _jsx(ArrowRight, { className: styles.arrow, size: 14 }, void 0)] }), void 0) }), void 0))] }), void 0) }), void 0));
};
export default MiniTile;
